<template>
  <GrayBlockContainer class="flex flex-col" style="gap: 24px">
    <FlexLayout v-loading="loading.signRecordDetail" col :gap="24">
      <AppointmentConsentFormReceipt
        v-for="(item, index) in appointmentConsentFormList"
        :key="index"
        :enableApplyScope="item.enableApplyScope"
        :name="item.name"
        :items="item.items"
        :status="item.status"
      />
    </FlexLayout>
  </GrayBlockContainer>
</template>

<script>
import { computed, defineComponent } from 'vue'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import FlexLayout from '@/components/FlexLayout.vue'
import AppointmentConsentFormReceipt from './AppointmentConsentFormReceipt.vue'
import { useCreateAppointment } from '@/use/useCreateAppointment'
import { get, map, uniqBy } from 'lodash'

export default defineComponent({
  name: 'AppointmentConsentForm',
  components: {
    GrayBlockContainer,
    AppointmentConsentFormReceipt,
    FlexLayout,
  },
  props: {
    details: { type: Array, default: () => [] },
  },
  setup (props) {
    const { loading } = useCreateAppointment()

    const signStatus = (signature) => {
      // 簽名紀錄是否已簽署
      // 已簽署 => isSigned 為 true
      // 未簽署 => isSigned 為 false, 存有作廢紀錄
      const isSigned = get(signature, 'isSigned', false)
      const isVoided = !!get(signature, 'signatureRecord.voidedAt', null)

      return isSigned && !isVoided
    }

    const appointmentConsentFormList = computed(() => {
      if (!props.details || props.details.length === 0) {
        return []
      }
      return map(uniqBy(props.details, 'signatureTemplateId'), (detail) => {
        const items = get(detail, 'signatureTemplate.applyScopeSetting', [])
        const enableApplyScope = get(detail, 'signatureTemplate.enableApplyScope')
        // const signatureDataTime = get(detail, 'signatureTemplate.signatureRecord.datetime', '')
        const status = signStatus(detail) ? '已簽署' : '未簽署'
        const name = get(detail, 'signatureTemplate.name', '')
        return {
          items,
          name,
          status,
          enableApplyScope,
        }
      })
    })

    return {
      loading,
      appointmentConsentFormList,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
